import { Component } from 'react';
import { connect } from 'react-redux';
import TableWithoutPaginationOrange from "../../Table/TableWithoutPaginationOrange"
import FormField from '../FormField'
import { getCurrentFunctionName } from '../../../performanceModeManager';
import { clone } from '../../../utils';
import FormMatrixHeaderField from './FormMatrixHeaderField';

class FormMatrixField extends Component {

    constructor(props) {
        super(props);

        let columnHeaders = [{ "title": "", id: false }].concat(props.metaQuestion.column_heading_ids)

        this.state = {
            rows: props.answers,
            columns: columnHeaders.map(ch => {
                if (ch.id)
                    return {
                        Header: ch.title,
                        id: ch.id,
                        filterable: false,
                        minWidth:70,
                        maxWidth: 70,
                        width: 70,
                        Cell: row => {
                            if (!row.row.original)
                                return null;

                            let answer = clone(row.row.original);

                            let responseAnswer = clone(this.props.question.response_answers.find(r => r.answer_id === answer.id && r.column_id === ch.id))

                            if (!responseAnswer)
                                responseAnswer = {//Si on a pas de réponse ça veut dire que la case n'est pas cochée ou non remplie
                                    column_id: ch.id,
                                    answer_id: answer.id,
                                    value: "",
                                    value_choice: false,
                                    response: this.props.question.id,
                                    answer: answer.answer,
                                }//On génère une réponse par défaut
                            else if (!responseAnswer.deleted && answer.type !== "integer") {
                                responseAnswer.value_choice = true;//S'il y a une réponse alors c'est coché (Le composant OpenERP ne semble pas remplir value_choice_id)
                            }

                            answer.answer = "";//On ne veut pas afficher les réponses à côté des champs (On est dans un tableau)

                            return (
                                <FormField responseValueChange={this.childrenValueChange(answer.id, ch.id)}
                                    disabled={this.props.inputProperties.disabled} id={answer.id.toString()} metaQuestion={answer}
                                    question={responseAnswer} subField visible={this.props.inputProperties.visible} centerfield 
                                    singlechoice={!this.props.multiple}
                                    save={this.props.save}
                                />
                            );
                        }
                    }
                else {
                    if (this.props.metaQuestion.answer_label_editable) {
                        return {
                            Header: ch.title, 
                            minWidth: 100,
                            width: 100,                            
                            maxWidth: 100,  
                            className: "large-text-cell",
                            Cell: row => {
                                let defaultAnswer = clone(row.row.original);

                                let surveyResponseAnswer = clone(this.props.question.response_answers.find(r => r.answer_id === defaultAnswer.id && !r.column_id))
                                if (!surveyResponseAnswer) {
                                    surveyResponseAnswer = {//Si on a pas de réponse ça veut dire que la case n'est pas cochée ou non remplie
                                        column_id: undefined,
                                        answer_id: defaultAnswer.id,
                                        value: "",
                                        value_choice: false,
                                        response: this.props.question.id,
                                        answer: defaultAnswer.answer,
                                    }//On génère une réponse par défaut
                                }

                                return <FormMatrixHeaderField responseValueChange={this.childrenValueChange(surveyResponseAnswer.answer_id, surveyResponseAnswer.column_id)} surveyResponseAnswer={surveyResponseAnswer}
                                    disabled={this.props.inputProperties.disabled} visible={this.props.inputProperties.visible} />
                            }
                        };
                    } else {
                        return {
                            Header: ch.title,
                            accessor: "answer",
                            minWidth: 100,
                            width: 100,                            
                            maxWidth: 100,    
                            className: "large-text-cell",
                        }
                    }                        
                }
            })
        }
    }

    static getDerivedStateFromProps(props, state) {
        let rows = props.answers;
        state.rows = [...rows];
        return state;
    }

    childrenValueChange = (answerId, columnId) => (newSurveyResponseAnswer) => {
        let responseAnswers = clone(this.props.question.response_answers);
        let responseAnswerIndex = responseAnswers.findIndex(r => r.answer_id === answerId && r.column_id === columnId)

        if (!this.props.multiple && columnId) {
            responseAnswers.filter(r => r.answer_id === answerId && r.column_id).forEach(ra => {
                ra.deleted = true;
                ra.value_choice = false;
            })
        }

        if (responseAnswerIndex === -1)
            responseAnswers.push(newSurveyResponseAnswer)
        else
            responseAnswers.splice(responseAnswerIndex, 1, newSurveyResponseAnswer)

        let response = clone(this.props.question);
        response.response_answers = responseAnswers
        this.props.responseValueChange(response);
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <div className="control-margin-top">
                <TableWithoutPaginationOrange
                    minRows={2}
                    {...this.props.inputProperties}
                    data={this.state.rows}
                    columns={this.state.columns}
                    sortable={false} 
                    firstColumnSticky={true}
                    centerResponseColumn={true}
                />
            </div>
        )
    }
}

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormMatrixField);
